import i18n from '@/lib/language'
const testPwd = (value) => {
  // const result1 = /^[\w\W]{8,30}$/.test(value)
  // const result2 = /[0-9]/.test(value)
  // const result3 = /[a-zA-Z]/.test(value)
  // if (result1 && result2 && result3) {
  //   return true
  // }
  // return false
  if (value.length >= 8) {
    return true
  }
  return false
}
const rules = {
  account: [
    { required: true, message: i18n.t('message["827"]'), trigger: 'blur' }
  ],
  password: [
    { required: true, message: i18n.t('message["784"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (!testPwd(value)) {
          callback(new Error(i18n.t('message["753"]')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  repeatPwd: [
    { required: true, message: i18n.t('message["890"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (!testPwd(value)) {
          callback(new Error(i18n.t('message["753"]')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  email: [
    { required: true, type: 'email', message: i18n.t('message["834"]'), trigger: 'blur' }
  ],
  validCode: [
    { required: true, message: i18n.t('message["824"]'), trigger: 'blur' }
  ],
  username: [
    { required: true, message: i18n.t('message["1498"]'), trigger: 'blur' }
  ],
  truename: [
    { required: true, message: i18n.t('message["666"]'), trigger: 'blur' }
  ],
  name: [
    { required: true, message: i18n.t('message["772"]'), trigger: 'blur' }
  ],
  tel: [
    { required: true, message: i18n.t('message["800"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        var errors = []
        if (value && (!/^1\d{10}$/.test(value))) {
          errors.push(
            new Error(
              i18n.t('message["1111"]')
            ))
        }
        return errors
        // if (value && (!/^1\d{10}$/.test(value))){
        //   callback('Two passwords that you enter is inconsistent!');
        // } else {
        //   callback();
        // }
      },
      trigger: 'change'
    }
  ],
  title: [
    { required: true, message: i18n.t('message["67"]'), trigger: 'blur' }
  ],
  identifynumber: [
    { required: true, message: i18n.t('message["786"]'), trigger: 'blur' }
  ]
}
export default rules
